import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils';

export const UserDashboardSettingsSchema = z.object({
  showBookmarks: transformNullish(z.boolean(), false),
  showLastCalcInput: transformNullish(z.boolean(), false),
  showLastCalcOutput: transformNullish(z.boolean(), false),
  showLastCalcReport: transformNullish(z.boolean(), false),
  showLastTransferSubjects: transformNullish(z.boolean(), false),
  showWaitingStatuses: transformNullish(z.boolean(), false),
  showSuspendedLoadings: transformNullish(z.boolean(), false),
  showCurrentNextLoadCalc: transformNullish(z.boolean(), false),
  showInputCollection: transformNullish(z.boolean(), false),
  showCommentSample: transformNullish(z.boolean(), false),
  showCommentOutput: transformNullish(z.boolean(), false),
  showCommentSubject: transformNullish(z.boolean(), false),
  showAllSubjects: transformNullish(z.boolean(), false),
  showCalendarInputDeadline: transformNullish(z.boolean(), false),
  showCalendarOutputDeadline: transformNullish(z.boolean(), false),
  showCalendarReportDeadline: transformNullish(z.boolean(), false),
  showCalendarOutputPublication: transformNullish(z.boolean(), false),
  showCalendarReportPublication: transformNullish(z.boolean(), false),
});
